export default __webpack_public_path__ + "f2c27754127e58efd382759550e3e7d5.svg";